/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Report_Kpi_Unpaid_DescriptionInputs */

const vi_report_kpi_unpaid_description = /** @type {(inputs: Report_Kpi_Unpaid_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tổng nợ chưa thu`)
};

/**

* @param {Report_Kpi_Unpaid_DescriptionInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const report_kpi_unpaid_description = /** @type {((inputs?: Report_Kpi_Unpaid_DescriptionInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Report_Kpi_Unpaid_DescriptionInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_report_kpi_unpaid_description(inputs)
});